import React, { useState, useEffect, useRef } from 'react';
import './FloatingClock.css';

const FloatingClock = ({ isVisible, onClose }) => {
  const [time, setTime] = useState(new Date());
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const clockRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Handlers para arrastar
  const handleMouseDown = (e) => {
    if (e.target.classList.contains('floating-clock-close')) return;
    
    setIsDragging(true);
    const rect = clockRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const newX = e.clientX - dragOffset.x;
    const newY = e.clientY - dragOffset.y;

    // Limites da tela
    const maxX = window.innerWidth - clockRef.current.offsetWidth;
    const maxY = window.innerHeight - clockRef.current.offsetHeight;

    setPosition({
      x: Math.max(0, Math.min(newX, maxX)),
      y: Math.max(0, Math.min(newY, maxY))
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Handlers para touch (mobile)
  const handleTouchStart = (e) => {
    if (e.target.classList.contains('floating-clock-close')) return;
    
    setIsDragging(true);
    const rect = clockRef.current.getBoundingClientRect();
    const touch = e.touches[0];
    setDragOffset({
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top
    });
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();

    const touch = e.touches[0];
    const newX = touch.clientX - dragOffset.x;
    const newY = touch.clientY - dragOffset.y;

    // Limites da tela
    const maxX = window.innerWidth - clockRef.current.offsetWidth;
    const maxY = window.innerHeight - clockRef.current.offsetHeight;

    setPosition({
      x: Math.max(0, Math.min(newX, maxX)),
      y: Math.max(0, Math.min(newY, maxY))
    });
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  // Event listeners globais
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDragging, dragOffset]);

  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return { hours, minutes, seconds };
  };

  const { hours, minutes, seconds } = formatTime(time);

  if (!isVisible) return null;

  return (
    <div 
      ref={clockRef}
      className={`floating-clock ${isDragging ? 'dragging' : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        position: 'fixed'
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    >
      <div className="floating-clock-header">
        <span className="floating-clock-title">Relógio</span>
        <button className="floating-clock-close" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="floating-clock-time">
        <span className="time-digit">{hours}</span>
        <span className="time-separator">:</span>
        <span className="time-digit">{minutes}</span>
        <span className="time-separator">:</span>
        <span className="time-digit">{seconds}</span>
      </div>
    </div>
  );
};

export default FloatingClock;